export const segHeight = 0.75;
export const segWidth = 1.5;
export const segPad = 0.1;
